import { createSignal, onCleanup, onMount } from 'solid-js';

import { createScene } from './engine/scene';

/**
 * `?freeze=<seconds>` renders one deterministic frame instead of animating.
 * Visual regression relies on it; it is also a convenient way to look hard at
 * one moment of the animation.
 */
function freezeAtSecondsFromLocation(): number | undefined {
  const raw = new URLSearchParams(window.location.search).get('freeze');
  if (raw === null) return undefined;
  const seconds = Number.parseFloat(raw);
  return Number.isFinite(seconds) ? seconds : undefined;
}

/**
 * Solid owns the UI chrome; Three.js owns the canvas.
 * The two talk through signals only - no Solid reactivity inside the render loop.
 */
export default function App() {
  const [fps, setFps] = createSignal(0);
  let canvas!: HTMLCanvasElement;

  onMount(() => {
    const scene = createScene(canvas, setFps, {
      freezeAtSeconds: freezeAtSecondsFromLocation(),
    });
    onCleanup(() => scene.dispose());
  });

  return (
    <main class="app">
      <canvas ref={canvas} class="viewport" />
      <div class="hud">
        <span class="hud__title">RetroAIGames</span>
        <span class="hud__stat">{fps()} fps</span>
      </div>
    </main>
  );
}
